import { ButtonWithLoading } from '@/components/buttons/ButtonWithLoading'
import React from 'react'

interface UserLogoutProps {
  handleCloseModal: () => void
  handleLogout: () => void
}

const UserLogout: React.FC<UserLogoutProps> = ({ handleCloseModal, handleLogout }) => {
  return (
    <div className='fixed inset-0 z-[65] flex items-center justify-center bg-black bg-opacity-50'>
      <div className='scale-[0.8] md:scale-100'>
        <div className='flex h-[299px] w-[421px] flex-col items-center justify-center rounded-lg bg-white p-6 shadow-lg '>
          <img src='/assets/payments/info-circle.png' alt='Info Icon' className='mt-5 h-[75px] w-[75px]' />
          <p className='mt-[30px] text-sm text-gray-500'>Are you sure you want to logout?</p>
          <div className='mb-[23px] mt-[21px] flex justify-end'>
            <ButtonWithLoading
              type='submit'
              title='no'
              disabled={false}
              isLoading={false}
              className='btn-rd-amber btn-hover-amber btn-disabled-grey col-span-full ml-auto mr-5 !inline h-[31px] w-[152px] text-sm'
              onClick={handleCloseModal}
            />
            <ButtonWithLoading
              type='submit'
              title='yes'
              disabled={false}
              isLoading={false}
              className='btn-rd-amber btn-hover-amber btn-disabled-grey col-span-full ml-auto !inline h-[31px] w-[152px] text-sm'
              onClick={handleLogout}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserLogout
